import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REVERT_REPLACE_DISH_TYPE_MUTATION } from '../graphql/mutations'
import { REVERT_REPLACE_DISH_TYPE } from '../redux/action-types'

const useRevertReplaceDishTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.dishTypes.dishTypes)

  const mutate = useCallback(
    async replaceToken => {
      await apolloService.mutate(
        REVERT_REPLACE_DISH_TYPE_MUTATION,
        {
          replaceToken,
        },
        dispatch,
        REVERT_REPLACE_DISH_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useRevertReplaceDishTypeMutation
